import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, makeStyles, MenuItem, Select, TextField, withStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import { batchCreateSecondDelivery, batchUpdateToGatewayOut, subBatchUpdateStatus } from '../../../actions/utActions';
import { getUserPreference } from '../../../utilities/common';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { adminServerInstance } from '../../../axios/instances';
import ReactExport from "react-export-excel";
import FullscreenLoading from '../../Common/FullscreenLoading';
import { Autocomplete } from '@material-ui/lab';
import _ from 'lodash';
import { getStaffList } from '../../../actions/mmActions';

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    selectWidth: {
        width: 200
    }
}));

function BatchUpdate(props) {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');
    const classes = useStyles();
    const userPref = getUserPreference();

    const staffList = useSelector(state => state.ddReducer.getLetianStaff);

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const fromStateList = [
        {
            status: '190',
            text: t('190')
        },
        {
            status: '192',
            text: t('192')
        },
        {
            status: '198',
            text: t('198')
        },
        {
            status: '199',
            text: t('199')
        },
    ]

    const [subBatches, setSubBatches] = useState('');
    const [loading, setLoading] = useState(false);
    const [serviceNos, setServiceNos] = useState('');
    const [notFound, setNotFound] = useState([]);
    const [updated, setUpdated] = useState([]);
    const [failed, setFailed] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [toState, setToState] = useState(195);
    const [fromStates, setFromStates] = useState([fromStateList[0]]);
    const [res, setRes] = useState(false);
    const [totalWeight, setTotalWeight] = useState();

    const handleServiceNos = (event) => {
        setServiceNos(event.target.value);
    }
    const handleSubBatches = (event) => {
        setSubBatches(event.target.value);
    };

    function handleRes(res, type, error) {
        if(res?.length > 0) {
            if(type === 'failed') {
                return res.map(tno => ({tno: tno, errorMessage: error}))
            } else {
                return res.map(tno => ({tno}))
            }
        } else {
            return [];
        }
    }
    
    function handleSubmit() {
        setLoading(true);
        let params = {
            'batches': transferNos(subBatches, false),
            'state': toState.toString(),
            'warehouse': userPref.userCity,
            'origin_state': _.map(fromStates, 'status').toString(),
            'shipping_staff_id': transferNos(serviceNos, true)
        };
        
        dispatch(subBatchUpdateStatus(params))
        .then((res) => {
            setTotalWeight(res.data.total_weight);
            setNotFound(handleRes(res.data.not_found));
            setUpdated(handleRes(res.data.updated));
            setFailed(handleRes(res.data.failed.tnos, 'failed', res.data.failed.errorMessage));
            setRes(true);
            setLoading(false);
            if(res.data.failed.tnos?.length > 0 || res.data.not_found.length > 0) {
                dispatch(showAlertSnackbar({message: t('update_warning'), type: 'warning'}))
            } else {
                dispatch(showAlertSnackbar({message: t('update_success'), type: 'success'}))
            }
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('update_fail'), type: 'error'}))
            setLoading(false);
        })
    }
    function transferNos(nos, isServiceNo) {
        let newNos = nos.split('\n');        
        let newNosCurr = '';
        newNos.forEach((element) => {
            if(element) {
                if(element.trim()) {
                    newNosCurr = newNosCurr.concat(',' + element.trim());
                    if(isServiceNo) {
                        if(!handleDynamicNos(element.trim())) {
                            dispatch(showAlertSnackbar({message: t('not_this_warehouse'), type: 'warning'}))
                        }
                    }
                }
            }
        });
        return newNosCurr.substring(1);
    }
    function handleDynamicNos(input) {
        if(staffList) {
            if(staffList.length > 0) {
                let found = false;
                staffList.map((staff) => {
                    if(input + '' === staff.id + '') {
                        found = true;
                    }
                })
                return found;
            }
        }
    }

    useEffect(() => {
        if(props.batchUpdate) {
            setRes(false);
            setSubBatches('');
            setServiceNos('');
            setNotFound([]);
            setUpdated([]);
            setFailed([]);
            setToState(195);
            setFromStates([fromStateList[0]]);
            setTotalWeight();
        }
    }, [props.batchUpdate])
    useEffect(() => {
        if(!subBatches || !toState || !fromStates?.length > 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [subBatches, fromStates])
    useEffect(() => {
        if(!staffList?.length > 0) {
            dispatch(getStaffList())
            .catch(() => {
                dispatch(showAlertSnackbar({message: t('common:fetch_data_fail'), type: 'error'}))
            })
        }
        setTotalWeight();
    }, [])

    return (
        <div 
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginBottom: 40
            }}
        >
            <div 
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                }}
            >
                <div style={{marginBottom: 20}}>
                    <div style={{marginBottom: 10}}>{t('from_state')}</div>
                    <Autocomplete
                        multiple
                        options={fromStateList}
                        getOptionLabel={(option) => option.text}
                        filterSelectedOptions
                        limitTags={1}
                        onChange={(event, value) => {
                            setFromStates(value)
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                            />
                        )}
                        style={{width: 300}}
                        value={fromStates}
                    />
                </div>
                <div>
                    <div style={{marginBottom: 10}}>{t('to_state')}</div>
                    <Select
                        variant='outlined'
                        value={toState}
                        defaultValue={`195`}
                        style={{width: 300}}
                        onChange={(event)=>{setToState(event.target.value)}}
                    >
                        <MenuItem value={195}>{t('195')}</MenuItem>
                        <MenuItem value={199}>{t('199')}</MenuItem>
                        <MenuItem value={255}>{t('255')}</MenuItem>
                    </Select>
                </div>
            </div>
            <div style={{marginLeft: 30}}>
                <div style={{marginBottom: 10}}>{t('sub_batches')}</div>
                <InputTextField
                    multiline
                    rows={6}
                    variant='outlined'
                    placeholder={t('input_batch_enter')}
                    onChange={handleSubBatches}
                    value={subBatches}
                />  
            </div>
            <div style={{marginLeft: 30}}>
                <div style={{marginBottom: 10}}>{t('service_nos_optional')}</div>
                <InputTextField
                    multiline
                    rows={6}
                    variant='outlined'
                    placeholder={t('input_service_enter')}
                    onChange={handleServiceNos}
                    value={serviceNos}
                />
            </div>
            <div 
                style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginLeft: 30
                }}
            >
                <div style={{ display: 'flex'}}>
                    <Button
                        color="primary"
                        variant="contained"
                        component="span"
                        disabled={loading || disabled}
                        onClick={handleSubmit}
                    >
                        {t('confirm_update')}
                    </Button>
                    {   res &&
                        <ExcelFile
                            element={
                                <Button
                                    color="primary"
                                    variant="contained"
                                    component="span"
                                    disabled={!res}
                                    style={{ marginLeft: 20 }}
                                >
                                    {t('download_report')}
                                </Button>
                            }
                        >
                            <ExcelSheet data={updated || []} name="Updated">
                                <ExcelColumn label="tno" value="tno"/>
                            </ExcelSheet>
                            <ExcelSheet data={notFound || []} name="Not Found">
                                <ExcelColumn label="tno" value="tno"/>
                            </ExcelSheet>
                            <ExcelSheet data={failed || []} name="Failed">
                                <ExcelColumn label="tno" value="tno"/>
                                <ExcelColumn label="errorMessage" value="errorMessage"/>
                            </ExcelSheet>
                        </ExcelFile>
                    }
                    
                    <FullscreenLoading open={loading} />
                </div>
                {
                    totalWeight &&
                    <div style={{textAlign: 'right', marginTop: 20}}>{t('total_weight')}{totalWeight}</div>
                }
            </div>
        </div>
    );
}

export default BatchUpdate;